var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPostAddBlack48Dp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 20 20",
    height: "48px",
    viewBox: "0 0 20 20",
    width: "48px",
    fill: "#4b5960",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 20,
    width: 20,
    x: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14,15H5V6h6V5H5C4.45,5,4,5.45,4,6V15c0,0.55,0.45,1,1,1H14c0.55,0,1-0.45,1-1V9h-1V15z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "7,8 7,9 11,9 12,9 12,8"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 5,
    x: 7,
    y: 10
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 5,
    x: 7,
    y: 12
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15,3 14,3 14,5 14,5 12,5 12,6 14,6 14,8 15,8 15,6 15,6 17,6 17,5 15,5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostAddBlack48Dp);
export default __webpack_public_path__ + "static/media/post_add_black_48dp.092650b8cff1cc04c6ad2b62dd718b5d.svg";
export { ForwardRef as ReactComponent };